import Vue from 'vue'
import App from './App.vue'
import ImageUploader from 'vue-image-upload-resize'
Vue.use(ImageUploader);
import VueRouter from 'vue-router'                             
Vue.use(VueRouter);
import VueCookie from 'vue-cookie';
Vue.use(VueCookie);
import router from './router/index'
Vue.config.productionTip = false
import store from './store'
import VueClazyLoad from 'vue-clazy-load'
Vue.use(VueClazyLoad)
new Vue({
 router, store,
  render: h => h(App), 
}).$mount('#app')
